<template>
  <b-modal
    ref="modal-pre-order-excel"
    hide-footer
    :title="titleExcel"
    id="modal-pre-order-excel"
    @shown="getHistoryExportExcel()"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel">
            <b-form-radio :value="EXPORT_MODE.ALL"
              >Tất cả các trang</b-form-radio
            >
            <b-form-radio :value="EXPORT_MODE.FILTER">Theo bộ lọc</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col cols="12" v-if="selectedListExcel === EXPORT_MODE.FILTER">
        <p class="text-muted font-italic mb-0">
          Xuất theo bộ lọc đang áp dụng ở danh sách.
        </p>
      </b-col>

      <b-col cols="12">
        <b-row v-if="selectedListExcel === EXPORT_MODE.ALL">
          <b-col md="4">
            <b-form-group>
              <label>Từ ngày: <span class="text-danger">*</span></label>
              <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="exportDates.fromDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Đến ngày: <span class="text-danger">*</span></label>
              <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="exportDates.toDate"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12">
        <p class="text-muted font-italic mb-0">
          Chỉ xuất được trong vòng {{ allowedRangeDays }} ngày gần nhất.
        </p>
        <p
          v-if="isFilterMode && !canExport"
          class="text-danger font-italic mb-0"
        >
          Chưa chọn khoảng ngày ở danh sách — chọn Từ ngày / Đến ngày rồi bấm
          Lọc.
        </p>
      </b-col>
    </b-row>

    <div>
      <hr
        class="hr-text"
        data-content="Lịch sử xuất excel"
        style="font-weight: 600"
      />
      <b-table
        class="myTable"
        caption-top
        responsive
        bordered
        hover
        :fields="fieldHistory"
        :items="histories"
      >
        <template v-slot:cell(actions)="row">
          <v-icon
            v-if="
              +row.item.processingStatus ===
              PROCESSING_DOWNLOAD_STATUS.COMPLETED
            "
            small
            class="text-primary"
            title="Tải xuống"
            v-b-tooltip
            :disabled="isSubmitting('download-' + row.item.id)"
            @click="downloadExcel(row.item.id)"
            >mdi-download</v-icon
          >
          <div
            v-else-if="
              +row.item.processingStatus ===
              PROCESSING_DOWNLOAD_STATUS.PROCESSING
            "
            class="d-flex align-items-center"
          >
            <b-progress height="20px" class="flex-grow-1">
              <b-progress-bar
                :value="row.item.process"
                :label="`${row.item.process}%`"
                animated
                variant="success"
              ></b-progress-bar>
            </b-progress>
            <v-icon
              small
              class="text-danger ml-2"
              title="Dừng tải xuống"
              v-b-tooltip
              :disabled="isSubmitting('cancel-' + row.item.id)"
              @click="cancelDownload(row.item.id)"
              >mdi-close</v-icon
            >
          </div>
          <div v-else class="d-flex align-items-center justify-content-center">
            <span class="text-danger">Xuất file thất bại</span>
            <v-icon
              small
              class="text-danger ml-2"
              title="Xoá khỏi danh sách"
              v-b-tooltip
              :disabled="isSubmitting('cancel-' + row.item.id)"
              @click="cancelDownload(row.item.id)"
              >mdi-close</v-icon
            >
          </div>
        </template>
      </b-table>
    </div>

    <SaveButton
      class="mr-3"
      :button-style="{
        fontWeight: '600',
        minWidth: '70px',
        whiteSpace: 'nowrap',
      }"
      :is-busy="isExporting"
      :disabled="!canExport"
      @click="exportToExcelStream"
    >
      <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
      <strong>Xuất Excel</strong>
    </SaveButton>

    <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      :disabled="isSubmitting('export')"
      @click="$bvModal.hide('modal-pre-order-excel')"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>

<script>
import { checkPermission } from '@/utils/saveDataToLocal';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import {
  MODULE_TYPE,
  PROCESSING_DOWNLOAD_STATUS,
  PRE_ORDER_EXPORT_LIMIT,
  EXPORT_MODE,
} from '@/utils/enum';
import ApiService from '@/core/services/api.service';
import fileDownload from '@/utils/file-download';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
import timeUtils from '@/utils/date';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';

const DATE_FORMAT = 'DD/MM/YYYY';
const DATE_DB_FORMAT = 'YYYY-MM-DD';
const POLLING_INTERVAL_MS = 5000;
const MAX_POLL_FAILURES = 5;

export default {
  props: ['param'],
  mixins: [submitLock],
  components: {
    datePicker,
    SaveButton,
  },
  data() {
    return {
      PROCESSING_DOWNLOAD_STATUS,
      EXPORT_MODE,
      dpConfigs: null,
      selectedListExcel: EXPORT_MODE.ALL,
      // Khoảng ngày riêng của chế độ "Tất cả các trang", cố ý ĐỂ TRỐNG để user tự chọn (chốt Đ1).
      exportDates: { fromDate: null, toDate: null },
      titleExcel: 'Xuất excel đơn đặt trước',
      histories: [],
      pollingIntervals: {},
      pollingFailures: {},
      // Số thứ tự lượt nạp lịch sử, để bỏ kết quả của lượt cũ về sau lượt mới.
      historyRequestId: 0,
      isDestroyed: false,
      fieldHistory: [
        {
          key: 'name',
          label: 'Tên File',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '80%' },
          tdClass: 'text-center',
        },
        { key: 'actions', label: '', tdClass: 'text-center' },
      ],
    };
  },
  created() {
    this.dpConfigs = timeUtils.DP_CONFIG;
  },
  beforeDestroy() {
    // Cờ riêng chứ không dùng historyRequestId: nhịp polling chạy nốt sau destroy tự tăng số lượt nên guard đó không chặn được, nó dựng lại interval mà không còn ai clear.
    this.isDestroyed = true;
    this.stopPolling();
  },
  computed: {
    // PreOrder.vue đã chuẩn hoá prop sẵn (map id, gộp $route.query, ngày YYYY-MM-DD); map lại lần nữa là lệch với lưới.
    filterParams() {
      return this.param || {};
    },
    allowedRangeDays() {
      let days = 30;

      if (checkPermission('EXPORT_WITHIN_90DAY')) {
        days = 90;
      } else if (checkPermission('EXPORT_WITHIN_60DAY')) {
        days = 60;
      }

      return Math.min(days, PRE_ORDER_EXPORT_LIMIT.MAX_RANGE_DAYS);
    },
    isFilterMode() {
      return this.selectedListExcel === EXPORT_MODE.FILTER;
    },
    dateSource() {
      return this.isFilterMode ? this.filterParams : this.exportDates;
    },
    canExport() {
      return Boolean(this.dateSource.fromDate && this.dateSource.toDate);
    },
    // Request trả về gần như tức thì nên khoá thêm theo bản ghi nào chưa đạt 100%.
    isExporting() {
      return (
        this.isSubmitting('export') ||
        this.histories.some(
          (item) =>
            +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING,
        )
      );
    },
  },
  methods: {
    exportToExcelStream() {
      return this.withSubmitLock('export', () => this.doExportToExcelStream());
    },
    async doExportToExcelStream() {
      const apiParams = this.getParamFilters();

      if (!apiParams) {
        return;
      }

      try {
        // Ghi file chạy nền, response chỉ báo đã nhận. Tải lại ở bảng lịch sử bên dưới.
        const { data } = await ApiService.query('pre-orders/export-excel', {
          params: apiParams,
        });
        makeToastSuccess(data.message);
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      } finally {
        this.$nprogress.done();
        // await để khoá giữ tới khi histories có dòng mới, tránh nút mở lại quá sớm.
        await this.getHistoryExportExcel();
      }
    },
    getParamFilters() {
      const source = this.dateSource;

      if (!source.fromDate || !source.toDate) {
        makeToastFaile(
          `Vui lòng chọn khoảng thời gian trong vòng ${this.allowedRangeDays} ngày.`,
        );
        return null;
      }

      // Chế độ lọc nhận sẵn YYYY-MM-DD từ PreOrder.vue, chế độ tất cả nhận DD/MM/YYYY từ date-picker.
      const inputFormat = this.isFilterMode ? DATE_DB_FORMAT : DATE_FORMAT;
      const from = moment(source.fromDate, inputFormat, true);
      const to = moment(source.toDate, inputFormat, true);

      // Parse strict TRƯỚC khi so: ngày hỏng cho ra chuỗi 'Invalid date', mà 'I' > '2' nên nó lọt qua mọi phép so chuỗi.
      if (!from.isValid() || !to.isValid()) {
        makeToastFaile('Khoảng thời gian không hợp lệ, vui lòng chọn lại.');
        return null;
      }

      const today = moment().startOf('day');

      // Ba mốc dưới soi đúng preOrderService.validateExportRangeDate, để báo lỗi ngay tại modal thay vì đợi 400.
      if (to.isBefore(from, 'day')) {
        makeToastFaile('Đến ngày phải lớn hơn hoặc bằng từ ngày!');
        return null;
      }

      if (from.isAfter(today, 'day')) {
        makeToastFaile('Từ ngày không được ở tương lai!');
        return null;
      }

      if (to.isAfter(today, 'day')) {
        makeToastFaile('Đến ngày không được lớn hơn hôm nay!');
        return null;
      }

      // So MỐC NEO giống BE, không đo độ dài cửa sổ — đo độ dài lệch đúng 1 ngày ở biên.
      const earliestAllowed = moment()
        .subtract(this.allowedRangeDays, 'day')
        .startOf('day');

      if (from.isBefore(earliestAllowed)) {
        makeToastFaile(
          `Vui lòng chọn khoảng thời gian trong vòng ${this.allowedRangeDays} ngày.`,
        );
        return null;
      }

      const apiParams = {
        exportMode: this.selectedListExcel,
        fromDate: from.format(DATE_DB_FORMAT),
        toDate: to.format(DATE_DB_FORMAT),
      };

      if (!this.isFilterMode) {
        return apiParams;
      }

      const productSearch = this.filterParams.productSearch
        ? this.filterParams.productSearch.trim()
        : null;

      // Giữ nguyên ngưỡng cũ của màn này: 2-4 ký tự bị chặn, 1 ký tự thì cho qua.
      if (
        productSearch &&
        productSearch.length < 5 &&
        productSearch.length > 1
      ) {
        makeToastFaile('Tên sản phẩm phải từ 5 kí tự trở lên');
        return null;
      }

      return {
        ...this.filterParams,
        ...apiParams,
        productSearch,
      };
    },
    async getHistoryExportExcel() {
      if (this.isDestroyed) {
        return;
      }

      const requestId = ++this.historyRequestId;

      try {
        // moduleType để lịch sử của màn này không lẫn với các màn xuất excel khác
        const { data } = await ApiService.query(
          'pre-orders/history-export-excel',
          {
            params: { moduleType: MODULE_TYPE.PRE_ORDER },
          },
        );

        if (!data.status) {
          return;
        }

        const rows = await Promise.all(
          data.data
            // Giữ cả bản ghi chưa có url: url do tiến trình nền ghi SAU khi response đã trả, lọc phẳng theo url là mất dòng vừa tạo lẫn dòng ERROR do chính lệnh ghi url hỏng.
            .filter(
              (item) =>
                item.url ||
                +item.processingStatus !== PROCESSING_DOWNLOAD_STATUS.COMPLETED,
            )
            .map(async (item) => {
              const isProcessing =
                +item.processingStatus ===
                PROCESSING_DOWNLOAD_STATUS.PROCESSING;
              let process = 100;

              if (isProcessing) {
                const progress = await this.getProcessDownload(item.id);
                process = progress ? progress.process : 0;
              }

              // Chưa có url thì điền chữ theo trạng thái, để ô trống thì user tưởng là dòng rác.
              let name = 'Không tạo được file';

              if (item.url) {
                name = item.url.split('/').pop();
              } else if (isProcessing) {
                name = 'Đang tạo file...';
              }

              return { ...item, name, process };
            }),
        );

        // Hàm này gọi từ 5 chỗ nên hai lượt dễ chồng nhau; lượt cũ về sau sẽ ghi đè bảng bằng trạng thái cũ hơn.
        if (requestId !== this.historyRequestId) {
          return;
        }

        this.histories = rows;
        // Bật polling SAU khi chắc là lượt mới nhất, tránh lượt cũ dựng lại interval cho bản ghi đã xong.
        rows.forEach((item) => {
          if (
            +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.PROCESSING
          ) {
            this.startPolling(item.id);
          }
        });
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      }
    },
    downloadExcel(id) {
      return this.withSubmitLock(`download-${id}`, () =>
        this.doDownloadExcel(id),
      );
    },
    async doDownloadExcel(id) {
      try {
        const response = await ApiService.query(
          `pre-orders/download-excel?id=${id}`,
          { responseType: 'blob' },
        );
        fileDownload.createFile(
          response.data,
          fileDownload.getFileName(response),
        );
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      } finally {
        // await để khoá giữ tới khi bảng bỏ dòng vừa tải — tải xong là BE hạ cờ downloaded và xoá file.
        await this.getHistoryExportExcel();
      }
    },
    cancelDownload(id) {
      return this.withSubmitLock(`cancel-${id}`, () =>
        this.doCancelDownload(id),
      );
    },
    async doCancelDownload(id) {
      try {
        // ApiService.delete tự nuốt lỗi (api.service.js:179-190), trả về error object nên phải kiểm data && data.status, không thì toast 2 lần.
        const { data } = await ApiService.delete(
          `pre-orders/cancel-process-excel?id=${id}`,
        );

        if (data && data.status) {
          makeToastSuccess(data.message);
        }
      } catch (err) {
        makeToastFaile(await this.getErrorMessage(err));
      } finally {
        this.stopPolling(id);
        // await để khoá giữ tới khi dòng đã biến khỏi bảng, không cho bấm huỷ lần hai.
        await this.getHistoryExportExcel();
      }
    },
    async getProcessDownload(id) {
      try {
        const { data } = await ApiService.get(
          `pre-orders/process-excel?id=${id}`,
        );

        return data.data;
      } catch (err) {
        return null;
      }
    },
    startPolling(id) {
      if (this.isDestroyed || this.pollingIntervals[id]) {
        return;
      }

      this.pollingIntervals[id] = setInterval(async () => {
        const progress = await this.getProcessDownload(id);

        // Mất mạng là tạm thời: chịu vài nhịp hỏng rồi mới bỏ, dừng ngay nhịp đầu là dòng kẹt PROCESSING và nút Xuất khoá theo.
        if (!progress) {
          this.pollingFailures[id] = (this.pollingFailures[id] || 0) + 1;

          if (this.pollingFailures[id] < MAX_POLL_FAILURES) {
            return;
          }

          this.stopPolling(id);
          return this.getHistoryExportExcel();
        }

        this.pollingFailures[id] = 0;

        this.histories = this.histories.map((item) =>
          item.id === id ? { ...item, process: progress.process } : item,
        );

        // BE trả process 100 cho cả bản ghi ERROR (ReportHistoryService.getProcessDownload) nên mốc 100 đã bao luôn ca lỗi.
        if (+progress.process === 100) {
          this.stopPolling(id);
          this.getHistoryExportExcel();
        }
      }, POLLING_INTERVAL_MS);
    },
    // Không truyền id thì dọn toàn bộ - dùng khi component bị huỷ.
    stopPolling(id) {
      const ids = id ? [id] : Object.keys(this.pollingIntervals);

      ids.forEach((key) => {
        clearInterval(this.pollingIntervals[key]);
        delete this.pollingIntervals[key];
        delete this.pollingFailures[key];
      });
    },
    async getErrorMessage(err) {
      if (!err.response) {
        return 'Không kết nối được máy chủ, vui lòng thử lại.';
      }

      const data = err.response.data;

      // Request blob thì body lỗi cũng là Blob, phải đọc text rồi parse mới ra message.
      if (data instanceof Blob) {
        try {
          const { message } = JSON.parse(await data.text());
          return message || 'Lỗi!';
        } catch (parseError) {
          return 'Lỗi!';
        }
      }

      return (data && data.message) || 'Lỗi!';
    },
  },
};
</script>
